import { render, staticRenderFns } from "./FastfoodView.vue?vue&type=template&id=3709123f&scoped=true"
import script from "./FastfoodView.vue?vue&type=script&lang=js"
export * from "./FastfoodView.vue?vue&type=script&lang=js"
import style0 from "./FastfoodView.vue?vue&type=style&index=0&id=3709123f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709123f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3709123f')) {
      api.createRecord('3709123f', component.options)
    } else {
      api.reload('3709123f', component.options)
    }
    module.hot.accept("./FastfoodView.vue?vue&type=template&id=3709123f&scoped=true", function () {
      api.rerender('3709123f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/cashier/FastfoodView.vue"
export default component.exports